import user from './user/user'
import chats from './chats/chats'
import messages from "./messages/messages"
import screenSize from './screenSize/screenSize'
import navTabs from './navTab/navTab'
import blockList from './blockList/blockList'
import language from './language/language'
import currency from './currency/currency'
import pageState from './pageState/pageState'
import internetStatus from './internetStatus/internetStatus'
import services from "./services/services"
import stickers from './stickers/stickers'
import scroll from './scroll/scroll'
import draft from './draft/draft'
import settings from './settings/settings'
import news from './news/news'
import supportTickets from './supportTickets/supportTickets'
import hints from './hints/hints'
import popupPositions from './popupPositions/popupPositions'
import alogixChat from './alogixChat/alogixChat'
import messagesSize from './messagesSize/messagesSize'
import messagesScrollOffset from './messagesScrollOffset/messagesScrollOffset'
import virtualKeyboard from './virtualKeyboard/virtualKeyboard'
import time from './time/time'
import subscriptions from './subscriptions/subscriptions'

const rootReducer = {
  user,
  chats,
  messages,
  screenSize,
  navTabs,
  blockList,
  language,
  currency,
  pageState,
  internetStatus,
  services,
  stickers,
  scroll,
  draft,
  settings,
  news,
  supportTickets,
  hints,
  popupPositions,
  alogixChat,
  messagesSize,
  messagesScrollOffset,
  virtualKeyboard,
  time,
  subscriptions
}

export default rootReducer
